import type {
  SegmentVacancyListCounts,
  VacancyOverride,
} from "@/features/segments/types";

export type CountAdjustment = {
  key: string;
  includedDelta: number;
};

export const overridesKeyOf = (overrides: VacancyOverride[]) =>
  JSON.stringify([...overrides].sort((a, b) => a.vacancyId - b.vacancyId));

export const applyCountAdjustments = (
  counts: SegmentVacancyListCounts & { fetchedFor: string },
  adjustments: CountAdjustment[],
): SegmentVacancyListCounts => {
  const reflectedUpTo = adjustments.findIndex(
    (adjustment) => adjustment.key === counts.fetchedFor,
  );
  const pendingDelta = adjustments
    .slice(reflectedUpTo + 1)
    .reduce((total, adjustment) => total + adjustment.includedDelta, 0);

  return {
    includedCount: counts.includedCount + pendingDelta,
    excludedCount: counts.excludedCount - pendingDelta,
  };
};
